<template>
	<div class="goodDiv">
		<el-tree
			style="width: 100%;margin-right:10px;"
			class="filter-tree"
			highlight-current
			:data="treedata"
			:props="defaultProps"
			:default-expand-all="true"
			@node-click="NodeClick"
			ref="tree"
			node-key="id"
			:show-checkbox="ctrlDisabled"
			:expand-on-click-node="false"
			:default-checked-keys="selectkeys"
			:check-on-click-node="false"
			@check="NodeClick"
		>
			<span class="custom-tree-node" slot-scope="{ node, data }">
				<span>{{ node.label }}</span>
				<span v-show="isshowTitle == true">
					<el-button type="text" size="mini" style="margin-left:10px;" @click.stop="append(data)">{{ $t('GoodsList.changbtn[1]') }}</el-button>
					<el-button type="text" size="mini" v-show="node.data.IsFather == false" style="margin-left:5px;" @click.stop="edit(data)">
						{{ $t('GoodsList.changbtn[0]') }}
					</el-button>
				</span>
			</span>
		</el-tree>

		<!-- <el-dialog :title="shopclassTitle" :visible.sync="showShopclass" :modal="false" :before-close="shopclassClose" style="width: 1500px;margin: 0 auto;">
			<el-form v-model="shopclassform">
				<el-form-item :label="$t('GoodsList.AddShopclass[0]')"><el-input v-model="shopclassform.name" style="width:500px;"></el-input></el-form-item>
				<el-form-item :label="$t('GoodsList.AddShopclass[1]')" v-show="showRadio">
					<el-radio @change="selectRadio" :disabled="Fdisable" v-model="radio" label="0">{{ $t('GoodsList.AddShopclass[2]') }}</el-radio>
					<el-radio @change="selectRadio" :disabled="Sdisable" v-model="radio" label="1">{{ $t('GoodsList.AddShopclass[3]') }}</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitShopclassform()">{{ $t('GoodsList.submitBtn') }}</el-button>
			</div>
		</el-dialog> -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import bus from '../bus';
import personelApi from '@/request/personelApi';
import wmsApi from '@/request/wmsApi';
export default {
	name: 'DepartmentTree',
	props: {
		isshowTitle: {
			required: false,
			default: false,
			type: Boolean
		},
		ctrlDisabled: {
			required: false,
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			treedata: [],
			defaultProps: {
				children: 'childList',
				label: 'name',
				disabled: function(data, node) {
					// console.log('data', data);
					// console.log('node', node);
					return data.disabled;
				}
			},
			selectkeys: [],

			shopclassTitle: '',
			showShopclass: false,
			shopclassform: {},
			radio: '1',
			showRadio: true,
			Sdisable: false,
			Fdisable: false,
			appendclass: '',

			allowDepart: []
		};
	},
	created() {
		this.GetDepartList();
		this.allowDepart = [];
		this.allowDepart.push(this.userData.deptid);
	},
	methods: {
		async GetDepartList() {
			this.treedata = [];
			let treeListRes = await personelApi.GetDepartList(this.token);
			// console.log('treeListRes: ', treeListRes);
			if (treeListRes.resultCode === 0) {
				if (this.ctrlDisabled) {
					treeListRes.data.forEach(item => {
						this.setAllItemDisabled(item);
					});
					this.treedata = treeListRes.data;
					await this.getAllowDepartList();
					this.treedata.forEach(item => {
						this.setItemEnable(item);
					});
					console.log('treedata->', this.treedata);
				} else {
					this.treedata = treeListRes.data;
				}
			}
		},

		setItemEnable(node) {
			if (this.allowDepart.indexOf(node.id) !== -1) {
				node.disabled = false;
			}
			if (node.childList && node.childList.length > 0) {
				node.childList.forEach(item => {
					this.setItemEnable(item);
				});
			}
		},

		setAllItemDisabled(node) {
			node.disabled = true;
			if (node.childList && node.childList.length > 0) {
				node.childList.forEach(item => {
					this.setAllItemDisabled(item);
				});
			}
		},

		async getAllowDepartList() {
			this.allowDepart = [];
			this.allowDepart.push(parseInt(this.userData.deptid));

			let sucRes = await wmsApi.GetAllowDepartByUser(this.token);
			if (sucRes.resultCode === 0) {
				sucRes.data.forEach(item => {
					this.allowDepart.push(item.id);
				});
			}
		},

		NodeClick(data) {
			console.log(data);
			if (!data.disabled) {
				let findObj = this.selectkeys.find(match => match === data.id);

				if (findObj) {
					this.selectkeys.splice(this.selectkeys.indexOf(findObj), 1);
				} else {
					this.selectkeys.push(data.id);
				}

				this.$emit('selectTreeClass', data);
			}
			// console.log(this.selectkeys);
		},

		append(e) {
			// console.log('e1', e);
			this.shopclassTitle = this.$t('GoodsList.changtitle[2]');
			this.showShopclass = true;
			this.showRadio = true;
			this.appendclass = e;

			let typename = this.GetGoodsTypeName(this.treedata, e.id);
			let tmpArr = typename.split('/');
			console.log(tmpArr);
			if (tmpArr.length == 1) {
				this.Fdisable = true;
				this.radio = '1';
				this.shopclassform.id = 0;
				this.shopclassform.pid = e.id;
			} else if (tmpArr.length < 3) {
				this.Fdisable = false;
				//下级
				if (this.radio === '1') {
					this.shopclassform.id = 0;
					this.shopclassform.pid = e.id;
				}
				//同级
				if (this.radio === '0') {
					this.shopclassform.id = 0;
					this.shopclassform.pid = e.pid;
				}
			} else {
				this.Sdisable = true;
				this.radio = '0';
				if (this.radio === '0') {
					this.shopclassform.id = 0;
					this.shopclassform.pid = e.pid;
				}
			}
		},
		selectRadio(e) {
			if (this.radio === '1') {
				this.shopclassform.id = 0;
				this.shopclassform.pid = this.appendclass.id;
			}
			if (this.radio === '0') {
				this.shopclassform.id = 0;
				this.shopclassform.pid = this.appendclass.pid;
			}
		},
		edit(e) {
			console.log('e2', e);
			// console.log('e2',a)
			this.shopclassTitle = this.$t('GoodsList.changtitle[3]');
			this.showShopclass = true;
			this.shopclassform = e;
			this.showRadio = false;
		},
		async submitShopclassform() {
			console.log(this.shopclassform);
			let shopclassRes = await wmsApi.CreateOrEditGoodsType(this.token, this.shopclassform);
			console.log('shopclassRes', shopclassRes);
			if (shopclassRes.errMsg == 'success!') {
				this.showShopclass = false;
				this.Sdisable = false;
				this.Fdisable = false;
				this.shopclassform = {};
				this.radio = '1';
				this.GetGoodsTypeList();
				this.$message({
					message: this.shopclassTitle + this.$t('GoodsList.msg[0]'),
					type: 'success'
				});
			} else {
				this.shopclassform = {};
				this.$message({
					message: this.shopclassTitle + this.$t('GoodsList.msg[1]'),
					type: 'warning'
				});
			}
		},
		shopclassClose() {
			this.showShopclass = false;
		},

		// 冒泡获取商品分类
		FindGoodsTypeByID(nowList, ID) {
			if (nowList == null || nowList.length == 0) return null;

			let typeModel = nowList.find(match => {
				return match.id == ID;
			});

			if (typeModel == null) {
				let result = null;
				for (let i = 0; i < nowList.length; i++) {
					result = this.FindGoodsTypeByID(nowList[i].childList, ID);
					if (result != null) break;
				}
				return result;
			} else return typeModel;
		},

		// 获取商品分类名称  1/2/3/4
		GetGoodsTypeName(typeList, TypeID) {
			let typeName = '';
			let HasFather = true;
			let tmpType = this.FindGoodsTypeByID(typeList, TypeID);
			console.log(tmpType);
			if (tmpType != null) {
				typeName += tmpType.name;
				while (HasFather) {
					tmpType = this.FindGoodsTypeByID(typeList, tmpType.pid);
					if (tmpType == null) HasFather = false;
					else typeName = tmpType.name + '/' + typeName;
				}
				return typeName;
			} else return typeName;
		}
	},
	computed: mapState({
		token: state => state.user.token,
		userData: state => state.user.userData
	}),
	watch: {}
};
</script>

<style>
/* .goodDiv{
		height: 100%;
		overflow: hidden;
		overflow-y: scroll;
	} */
</style>



// WEBPACK FOOTER //
// src/components/common/PersonnelComm/DepartmentTree.vue